// extracted by mini-css-extract-plugin
module.exports =  {"logo":"logo-tG3F3","loading":"loading-MHJng","name":"name-hABV7"};